export default "__VITE_ASSET__2Qly7Av4__"